export default __webpack_public_path__ + "static/media/eoy.1713c759.png";